import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class CompromissoService {
  private abrirCompromissoSource = new Subject<string>();

  abrirCompromisso$ = this.abrirCompromissoSource.asObservable();

  constructor() { }

  abrirNovoCompromisso(data: string) {
    this.abrirCompromissoSource.next(data);
  }
}
